import { useEffect } from "react";

export default function SlideOver({
  open,
  onClose,
  title,
  children,
  footer,
  widthClass = "max-w-3xl", // adjust: max-w-xl, max-w-2xl, max-w-4xl, etc.
}) {
  // Lock body scroll + prevent interaction behind
  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    const prevPaddingRight = document.body.style.paddingRight;

    // Prevent layout shift when scrollbar disappears
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999]"
      aria-modal="true"
      role="dialog"
    >
      {/* Backdrop (blocks clicks) */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      {/* Panel container (fixed, full height) */}
      <div className="absolute inset-y-0 right-0 flex w-full justify-end pointer-events-none">
        <div
          className={`pointer-events-auto h-full w-full ${widthClass} bg-gray-50 shadow-2xl flex flex-col transform transition-transform duration-200 translate-x-0`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header (sticky) */}
          <div className="shrink-0 bg-white border-b px-6 py-4 flex items-center justify-between">
            <h2 className="text-lg font-semibold">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              className="rounded-md p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Content (scrollable) */}
          <div className="flex-1 overflow-y-auto px-6 py-6">
            {children}
          </div>

          {/* Footer (sticky) */}
          {footer ? (
            <div className="shrink-0 bg-white border-t px-6 py-4">
              {footer}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
